// extracted by mini-css-extract-plugin
export default {"modalStyles":"styles_modalStyles__dMN7w","modalHideStyles":"styles_modalHideStyles__0ia66"};